import Vue from 'vue'
import Vuex from 'vuex'
import caminos from '../modules/caminos'
import reservas from '../modules/reservas'
import auth from '../modules/authentication'
import paises from './modules/paises'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    loading: false,
    dark: true,
    pantallaActiva: null,
    drawer: false,
    // Tema Azul-Amarillo
    colorAmarillo1: '#F9F6CD',
    colorAmarillo2: '#D5D397',
    colorAmarillo3: '#B2AF60',
    
    colorAceituna1: '#BAD1C1',
    colorAceituna2: '#8BA393',
    colorAceituna3: '#5A7564',

    colorVerde1: '#4FA195',
    colorVerde2: '#2B9D8B',
    colorVerde3: '#0A9A80',

    colorAzul1: '#2C6BB5',
    colorAzul2: '#21508C',
    colorAzul3: '#143461',

    colorGrisClaro: '#D4D6D9',

    // Tema VerdeOpaco-Mostaza
    colorBlanco: '#FFFFFF',
    colorMostazaOscuro: '#C99C33',
    colorMostazaClaro: '#D6A217',
    colorAzul: '#1890B3',
    colorTurquesa: '#18B3A7',
    colorVerdeOpacoOscuro: '#3D5654',
    colorVerdeOpacoClaro: '#425C5A',
    colorFondoOscuro: '#CADFDE',
    colorFondoClaro: '#E3F2F1',

    colorFondo: null,
    colorFondoDialog: null,
    colorNavigationMenu: null,
    colorBarraFormulario: null,
    colorBarraFormularioSecundario: null,
    colorAccent1: null,
    colorAccent2: null,
    colorAccent3: null,


    provincias: [
      'Álava', 'Albacete', 'Alicante', 'Almería', 'Asturias', 'Ávila', 'Badajoz', 'Barcelona', 'Burgos', 'Cáceres',
      'Cádiz', 'Cantabria', 'Castellón', 'Ciudad Real', 'Córdoba', 'Cuenca', 'Gerona', 'Granada', 'Guadalajara',
      'Guipúzcoa', 'Huelva', 'Huesca', 'Islas Baleares', 'Jaén', 'A Coruña', 'La Rioja', 'Las Palmas', 'León',
      'Lérida', 'Lugo', 'Madrid', 'Málaga', 'Murcia', 'Navarra', 'Orense', 'Palencia', 'Pontevedra', 'Salamanca',
      'Santa Cruz de Tenerife', 'Segovia', 'Sevilla', 'Soria', 'Tarragona', 'Teruel', 'Toledo', 'Valencia',
      'Valladolid', 'Vizcaya', 'Zamora', 'Zaragoza'
    ].sort((a, b) => a.localeCompare(b, 'es', { sensitivity: 'base' })),


    

    
   
  },

  mutations: {
    setLoading (state, bool){
      state.loading = bool
    },

    setDrawer (state, value){
      state.drawer = value;
    },

    setThemeVerdeOpacoMostaza(state, bool){
      state.colorFondo = state.colorFondoOscuro;
      state.colorFondoDialog = state.colorBlanco;
      state.colorAccent1 = state.colorMostazaClaro;
      state.colorAccent2 = state.colorMostazaOscuro;
      state.colorAccent3 = state.colorAzul;
      state.colorNavigationMenu = state.colorVerdeOpacoClaro;
      state.colorBarraFormulario = state.colorVerdeOpacoOscuro;
      state.colorBarraFormularioSecundario = state.colorVerdeOpacoClaro;
   },

    setThemePrimary(state, bool){
       state.colorFondo = state.colorGrisClaro;
       state.colorFondoDialog = state.colorBlanco;
       state.colorAccent1 = state.colorVerde3;
       state.colorNavigationMenu = state.colorAzul3;
    },

    setDark (state, bool){
      state.dark = bool;
      if (state.dark){
        state.colorFondo500 = state.colorDark500;
        state.colorFondo400 = state.colorDark400;
        state.colorFondo300 = state.colorDark300;
        state.colorFondo200 = state.colorDark200;
        state.colorFondo100 = state.colorDark100;

        state.colorFront500 = state.colorLight500;
        state.colorFront400 = state.colorLight400;
        state.colorFront300 = state.colorLight300;
        state.colorFront200 = state.colorLight200;
        state.colorFront100 = state.colorLight100;
      }else{
        state.colorFondo500 = state.colorLight500;
        state.colorFondo400 = state.colorLight400;
        state.colorFondo300 = state.colorLight300;
        state.colorFondo200 = state.colorLight200;
        state.colorFondo100 = state.colorLight100;

        state.colorFront500 = state.colorDark500;
        state.colorFront400 = state.colorDark400;
        state.colorFront300 = state.colorDark300;
        state.colorFront200 = state.colorDark200;
        state.colorFront100 = state.colorDark100;

      }
    }
  },
  actions: {
    


  },
  modules: {
    caminos,
    reservas,
    paises,
    auth
  }
})
